
import Form from './Form.vue'
import { useStore } from 'vuex'
import { defineComponent, ref, onMounted, computed, toRefs, reactive } from 'vue'

export default defineComponent({
  components: {
    Form
  },
  setup () {
    const form = reactive({
      id: '',
      code: '',
      name: '',
    })
    const form_action = ref('save')
    const visible = ref(false)
    const store = useStore()

    const fields = ref([
      {
        title: 'Tank Code',
        dataIndex: 'code',
      },
      {
        title: 'Tank Name',
        dataIndex: 'name',
      },
      // {
      //   title: "Is Active",
      //   dataIndex: "is_active",
      //   align: 'center',
      //   slots: { customRender: "is_active" }
      // },
      {
        title: 'Action',
        dataIndex: 'action',
        slots: {customRender: 'action'},
        align: 'center'
      },
    ])

    const index = (payload = {page: 1}) => {
      store.dispatch('Tank/index', payload)
    }

    const editRecord = (record: any) => {
      form_action.value = 'update'
      const {id, code, name} = toRefs(form)
      id.value = record.id
      code.value = record.code
      name.value = record.name
      visible.value = true
    }

    const createRecord = () => {
      form_action.value = 'save'
      const {id, code, name} = toRefs(form)
      id.value = ''
      code.value = ''
      name.value = ''
      visible.value = true
    }

    const deleteRecord = (record: any) => {
      store.dispatch('Tank/destroy', record.id)
    }

    const handleSaving = (record: any) => {
      form_action.value == 'save' ? storeRecord(record) : updateRecord(record)
    }

    const storeRecord = (payload = {}) => {
      store
          .dispatch('Tank/store', payload)
          .then(() => (visible.value = false))
    }

    const updateRecord = (payload = {}) => {
      store
          .dispatch('Tank/update', payload)
          .then(() => (visible.value = false))
    }

    const filterRecord = (payload: any) => {
      index(payload)
    }

    const items = computed(() => store.getters['Tank/items'])
    const loading = computed(() => store.getters['Tank/status'])

    onMounted(index)

    return {
      loading,
      items,
      fields,
      visible,
      form,
      editRecord,
      deleteRecord,
      storeRecord,
      createRecord,
      updateRecord,
      handleSaving,
      filterRecord
    }
  },
})
